import React from 'react';

interface SearchBoxProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: (query: string) => void;
  searchPlaceholder?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({
  value,
  onChange,
  onSearch,
  searchPlaceholder = 'Search...'
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(value);
    }
  };

  return (
    <div className="search-input-wrapper">
      <input
        type="text"
        placeholder={searchPlaceholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
      <svg className="search-icon" aria-hidden="true">
        <use xlinkHref="#search-icon" />
      </svg>
    </div>
  );
};

export default SearchBox;
